/**
 * @generated SignedSource<<1c8da9694d51370600dfc3acc564686a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteDeliverableInput = {
  id: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type DeleteDeliverableMutation$variables = {
  input: DeleteDeliverableInput;
};
export type DeleteDeliverableMutation$data = {
  readonly deleteDeliverable: {
    readonly deletedDeliverableId: string | null;
  } | null;
};
export type DeleteDeliverableMutation$rawResponse = {
  readonly deleteDeliverable: {
    readonly deletedDeliverableId: string | null;
  } | null;
};
export type DeleteDeliverableMutation = {
  variables: DeleteDeliverableMutation$variables;
  response: DeleteDeliverableMutation$data;
  rawResponse: DeleteDeliverableMutation$rawResponse;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteDeliverablePayload",
    "kind": "LinkedField",
    "name": "deleteDeliverable",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedDeliverableId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteDeliverableMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteDeliverableMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b3c8a1c298ca181684b44b7ff823e3fe",
    "id": null,
    "metadata": {},
    "name": "DeleteDeliverableMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteDeliverableMutation(\n  $input: DeleteDeliverableInput!\n) {\n  deleteDeliverable(input: $input) {\n    deletedDeliverableId\n  }\n}\n"
  }
};
})();

(node as any).hash = "0e96114f7094107ce892c611cdb1f131";

export default node;
